const OPTIONS = {
  currentPage: 1,
  totalPages: 10,
  nextPageDistance: 2,
  previousPageDistance: 2
}
const range = (start, end) =>
  Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx)
const usePaginator = (options = OPTIONS) => {
  options = { ...OPTIONS, ...options }
  const page =
    options.currentPage > options.totalPages
      ? options.totalPages
      : options.currentPage < 1
        ? 1
        : options.currentPage
  const totalPages = options.totalPages
  const previousPageNumber = page > 1 ? page - 1 : null
  const nextPageNumber = page < totalPages ? page + 1 : null
  const previousPages = []
  const nextPages = []
  {
    const totalRequiredButtons =
      options.previousPageDistance + options.nextPageDistance + 1
    const numbers = []
    if (page - options.previousPageDistance < 1) {
      numbers.push(...range(1, Math.min(totalPages, totalRequiredButtons)))
    } else if (page + options.nextPageDistance > totalPages) {
      const overflowedPageCount = Math.abs(
        totalPages - (page + options.nextPageDistance)
      )
      const totalRequiredPage =
        options.previousPageDistance + overflowedPageCount
      const [min, max] = [Math.max(page - totalRequiredPage, 1), totalPages]
      numbers.push(...range(min, max))
    } else {
      const [min, max] = [
        Math.max(page - options.previousPageDistance, 1),
        Math.min(page + options.nextPageDistance, totalPages)
      ]
      numbers.push(...range(min, max))
    }
    previousPages.push(...numbers.filter(o => o < page))
    nextPages.push(...numbers.filter(o => o > page))
  }
  return new Paginator({
    currentPage: page,
    totalPages: totalPages,
    previousPage: previousPageNumber
      ? {
        page: previousPageNumber,
        pages: previousPages
      }
      : null,
    nextPage: nextPageNumber
      ? {
        page: nextPageNumber,
        pages: nextPages
      }
      : null
  })
}

export class Paginator {
  /**
   *
   * @param {{
   * currentPage: number,
   * totalPages: number,
   * previousPage: {page: number, pages: number[]} | null
   * nextPage: {page: number, pages: number[]} | null
   * }} result
   */
  constructor(result) {
    this.result = result
  }
}

export function makePageUrl(baseSlug, page) {
  if (page === 1) {
    return baseSlug
  } else if (page > 1) {
    return `${baseSlug}/${page}`
  }
  return null
}
export default usePaginator
